import React, { useState } from "react";
import styled, { css } from "styled-components";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    imgPath: "/assets/icons/loginframe.png",
    TextHeader: "Receive money from customers with pay by bank",
    MidText:
      "Streamline your payment options and take control of your revenue.",
    CardImg: "/assets/icons/invoice-slip.png",
  },
  {
    imgPath: "/assets/icons/loginframe2.png",
    TextHeader:
      "Unleash the power of simplicity and security with our tokenization",
    MidText: "Fast and secure Paymetnt.",
    CardImg: "/assets/icons/invoice-slip2.png",
  },
];

const StepperContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
`;

const StepperImage = styled.div`
  max-width: 60%;
  overflow: hidden;
  margin: 0 auto;
`;

const ImagePic = styled.img`
  width: 100%;
  height: auto;
  border: 8px solid white;
  box-sizing: border-box;
  position: relative;
  border-radius: 120px 0 120px 0;
`;

const ImageCard = styled.img<{ $alignRight?: boolean }>`
  position: absolute;
  z-index: 1;
  top: 5%;

  ${({ $alignRight }) =>
    $alignRight
      ? css`
          left: 40%;
        `
      : css`
          right: 40%;
        `}
`;
const ImageOverallContainer = styled.div`
  position: relative;
`;

const StepperTextHeaderContainer = styled.div``;

const StepperTextHeader = styled.p`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.heading3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  text-align: center;
  letter-spacing: 0px;
  color: ${colors.NAVYBLUE};
`;

const StepperMidText = styled.p`
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  text-align: center;
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  color: ${colors.DARK_GRAY};
`;

const StepperPaginationDots = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;

  .dot {
    height: 10px;
    width: 10px;
    background-color: #bbb;
    border-radius: 50%;
    margin: 0 5px;
    cursor: pointer;

    &.active {
      background-color: #00c703;
    }
  }
`;

const Stepper = () => {
  const [activeStep, setActiveStep] = useState(0);

  const handleStepChange = (step: any) => {
    setActiveStep(step);
  };

  return (
    <StepperContainer>
      {activeStep === 0 ? (
        <ImageCard src="/assets/icons/invoice-slip.png" alt="" />
      ) : (
        <ImageCard src="/assets/icons/invoice-slip2.png" alt="" $alignRight />
      )}
      <StepperImage>
        <AutoPlaySwipeableViews
          index={activeStep}
          onChangeIndex={handleStepChange}
          interval={3000}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <ImageOverallContainer>
              <ImagePic key={index} src={step.imgPath} alt="" />
              <StepperTextHeaderContainer>
                <StepperTextHeader>{step.TextHeader}</StepperTextHeader>
                <StepperMidText>{step.MidText}</StepperMidText>
              </StepperTextHeaderContainer>
            </ImageOverallContainer>
          ))}
        </AutoPlaySwipeableViews>
      </StepperImage>
      <StepperPaginationDots>
        {images.map((step, index) => (
          <div
            key={index}
            className={`dot ${index === activeStep ? "active" : ""}`}
            onClick={() => handleStepChange(index)}
          />
        ))}
      </StepperPaginationDots>
    </StepperContainer>
  );
};

export default Stepper;
